import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "MyWidgetProfile" })
export default class MyWidgetProfile extends Vue {
    public localizer: any = Localizer;
    public firstLetters: string = null;
    public data: any = null;
    public isCompleted: boolean = false;
    public isDialogVisible: boolean = false;
    public isLoading: boolean = true;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        this.isLoading = true;
        this.data = (await Axios.post(this.routes.MyBremboPartsDashboard_GetWidgetProfileData, null)).data;

        if (this.data.name) {
            this.firstLetters = this.data.name.charAt(0) + this.data.surname.charAt(0);
            this.isCompleted = true;
        } else {
            this.firstLetters = this.data.email.slice(0, 2);
        }

        this.isLoading = false;
    }

    public showDialog() {
        this.isDialogVisible = !this.isDialogVisible;
    }

    public setAnalytics() {
        GTagHelper.sendEvent("file_download", "bremboexpert_certificate");
    }
};